import * as Colors from "../../../../globalStyles/administratorColors";

export const body = {
    paddingRight: "30px",
    paddingLeft: "10px"
};
export const planTitle = {
    textAlign: "center"
};

export const sectionHeading = {
    borderBottom: "2px solid",
    fontSize: "1.5rem",
    color: Colors.primary
};

export const sectionHeadingBtn = {
    borderBottom: "2px solid",
    textAlign: "right",
    color: Colors.primary
};

export const usersSection = {
    paddingTop: "10px",
    paddingLeft: "20px",
    paddingRight: "20px",
    paddingBottom: "30px"
};

export const userCard = {
    background: Colors.primary,
    color: "white"
};

export const deleteBtnSection = {
    textAlign: "right"
};
